export enum ComponentCompositionAssetKind {
  FontSchema = 'fontSchema',
  ColorPalette = 'colorPalette',
  Background = 'background',
  Clipart = 'clipart',
}
